module.exports = __webpack_public_path__ + "img/1545748589.974c076d.jpg";